module.exports = __webpack_public_path__ + "static/media/giftCard.8e52a665.png";